

















import Vue from 'vue';
import SSIDCell from './SSIDCell.vue';
import { LightStatus } from '@/store';
import DeviceType from '@/enums/DeviceType';

export default Vue.extend({
  name: 'SelectAP',
  components: {
    SSIDCell,
  },
  computed: {
    ssidList(): Array<{ name: string; key: number }> {
      let i = 0;
      let ssids = new Set<string>(this.$store.state.visibleSSIDs).values();
      const dt = Array.from(ssids).map(el => ({
        name: el,
        key: i++,
      }));
      return dt;
    },
    errorDescription(): string {
      switch (this.$store.state.lightStatus) {
        case LightStatus.APNotFound:
          switch (this.$store.state.deviceType) {
            case DeviceType.Light:
              return (
                Vue.i18n.translate('Wifi_Connection_AP_Not_Found_Light') || ''
              );
            case DeviceType.Plug:
              return (
                Vue.i18n.translate('Wifi_Connection_AP_Not_Found_Smart_Plug') ||
                ''
              );
            case DeviceType.WiFiSwitch:
              return (
                Vue.i18n.translate(
                  'Wifi_Connection_AP_Not_Found_WiFi_Switch',
                ) || ''
              );
          }
        case LightStatus.ConnectionFailed:
          return Vue.i18n.translate('Wifi_Connection_Failed_To_Connect') || '';
        default:
          return '';
      }
    },
  },
  methods: {
    onSSIDClick(SSIDName: string) {
      this.$store.commit('clearStateToEnterSSID');
      this.$store.commit('updateSSID', SSIDName);
      this.$store.commit('updatePairingStatus', {
        type: 'waitingForCredentials',
        ssidNotFound: false,
        passwordIsWrong: true,
        ssidList: [],
      });
    },
  },
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SelectAP.vue